import {
  Directive,
  ElementRef,
  inject,
  input,
  OnDestroy,
  output
} from "@angular/core";
import { Observable, Subscriber, Subscription } from "rxjs";
import { debounceTime, skip, tap } from "rxjs/operators";

@Directive({
  selector: "[resizeObserver]",
  standalone: false
})
export class ResizeObserverDirective implements OnDestroy {
  debounce = input<number>(500);

  sizeChange = output<void>();

  private readonly elementRef: ElementRef<HTMLElement> = inject(ElementRef);

  private readonly resizeObserver: ResizeObserver;

  private readonly observable: Observable<void>;
  private readonly subscription: Subscription;

  constructor() {
    let subscriber: Subscriber<void>;

    this.observable = new Observable<void>((_subscriber) => {
      subscriber = _subscriber;
    });

    this.subscription = this.observable
      .pipe(
        debounceTime(this.debounce()),
        skip(1),
        tap(() => {
          this.sizeChange.emit();
        })
      )
      .subscribe();

    this.resizeObserver = new ResizeObserver(() => {
      subscriber.next();
    });

    this.resizeObserver.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver.disconnect();
    this.subscription.unsubscribe();
  }
}
